import { render, staticRenderFns } from "./ColorSwitcher.vue?vue&type=template&id=5a6dda50&"
import script from "./ColorSwitcher.vue?vue&type=script&lang=js&"
export * from "./ColorSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a6dda50')) {
      api.createRecord('5a6dda50', component.options)
    } else {
      api.reload('5a6dda50', component.options)
    }
    module.hot.accept("./ColorSwitcher.vue?vue&type=template&id=5a6dda50&", function () {
      api.rerender('5a6dda50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/ColorSwitcher.vue"
export default component.exports